export default __webpack_public_path__ + "static/media/health.f01de47a.svg";